export const CSS = {
  // Visibility
  HIDDEN: "hidden",
  FLEX: "flex",

  // Dropdown states
  OPACITY_0: "opacity-0",
  OPACITY_100: "opacity-100",
  INVISIBLE: "invisible",
  VISIBLE: "visible",
  TRANSLATE_Y_0: "translate-y-0",
  TRANSLATE_Y_1: "translate-y-1",
  TRANSLATE_Y_NEG_2: "-translate-y-2",
  ROTATE_180: "rotate-180",
  SCALE_0: "scale-0",
  SCALE_100: "scale-100",

  // Tabs
  BG_CARD: "bg-card",
  TEXT_FOREGROUND: "text-foreground!",
  TEXT_MUTED_FOREGROUND: "text-muted-foreground",

  // Logo animation
  LOGO_DOWNLOADING: "logo-downloading",
  LOGO_DOWNLOADING_STOP: "logo-downloading-stop",
} as const;

export type CssClass = (typeof CSS)[keyof typeof CSS];
